module.exports = __webpack_public_path__ + "a597f9fd28eea71c60a112d78524f3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/repanda.png
// module id = 77
// module chunks = 0